function p(r, e) {
  return e - r;
}
function f(r, e, o) {
  const m = p(16, 84),
    u = 84 - m / 2 - 11 / 2,
    h = o.price_min,
    s = o.price_p33,
    d = o.price_p50,
    M = o.price_p66,
    l = o.price_max;
  let i = 0,
    t = 0,
    n = 0,
    c = 0;
  if (r === 0) {
    const a = p(h, s);
    a === 0 ? i = u : (n = m / a, c = e - h, t = 16 + Math.round(c * n), i = Math.max(16, Math.min(t, 84)));
  } else if (r === 1) {
    const a = p(s, M);
    a === 0 ? i = u : (n = m / a, c = e - d, t = u + Math.round(c * n), i = t > 0 ? Math.min(t, 84) : Math.max(t, 16));
  } else {
    const a = p(M, l);
    a === 0 ? i = u : (n = m / a, c = e - M, t = 16 + Math.round(c * n), i = Math.max(16, Math.min(t, 84)));
  }
  return i;
}
export { p as computeAmplitude, f as default };